module.exports = __webpack_public_path__ + "img/location_map_img.92b490b5.jpg";